<p-toolbar styleClass="mb-4" reflow="true">
  <ng-template pTemplate="left"></ng-template>
  <ng-template pTemplate="right">
    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
      class="p-button-help"></button>
    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
  </ng-template>
</p-toolbar>
<!-- <p-toast></p-toast> -->
<div class="app-verification-container">
  <p-card styleClass="p-card-shadow">
    <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
    <div class="card dashboardTable">
      <p-table #appVerificationTable [value]="BOQtableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
          'appID',
          'FarmerName',
          'village',
          'block',
          'district',
          'AgeOfApplication',
          'ProgrammeName',
          'LandDetail',
          'Total_Area',
          'PendingCompletedDays',
          'Status_Ar',
          'status',
          'DeptRemarks',
          'EstimationStatus',
          'FinYear'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
          <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">{{'BILL_OF_QUANTITY_DETAILS'| translate}}</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="
                  appVerificationTable.filterGlobal(
                    $any($event.target).value,
                    'contains'
                  )
                " placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th> -->
            <th pSortableColumn="appID">
              {{'APP_ID'| translate}}
              <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
              <p-sortIcon field="appID"></p-sortIcon>
            </th>
            <th pSortableColumn="FarmerName">
              {{'FARMER_NAME'| translate}}
              <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
              <p-sortIcon field="FarmerName"></p-sortIcon>
            </th>
            <th pSortableColumn="village">
              {{'VILLAGE'| translate}}
              <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
              <p-sortIcon field="village"></p-sortIcon>
            </th>
            <th pSortableColumn="block">
              {{'BLOCK'| translate}}
              <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
              <p-sortIcon field="block"></p-sortIcon>
            </th>
            <th pSortableColumn="district">
              {{'DISTRICT'| translate}}
              <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
              <p-sortIcon field="district"></p-sortIcon>
            </th>
            <th pSortableColumn="AgeOfApplication">
              {{'AGE_OF_APPLICATION'| translate}}
              <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
              <p-sortIcon field="AgeOfApplication"></p-sortIcon>
            </th>
            <th pSortableColumn="ProgrammeName">
              {{'PROGRAMME_NAME'| translate}}
              <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
              <p-sortIcon field="ProgrammeName"></p-sortIcon>
            </th>
            <th pSortableColumn="LandDetail">
              {{'LAND_DETAIL'| translate}}
              <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
              <p-sortIcon field="LandDetail"></p-sortIcon>
            </th>
            <th pSortableColumn="Total_Area">
              {{'TOTAL_AREA'| translate}}
              <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
              <p-sortIcon field="Total_Area"></p-sortIcon>
            </th>
            <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS'| translate}}
              <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
              <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
            </th>
            <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
              <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
              <p-sortIcon field="Status_Ar"></p-sortIcon>
            </th>
            <th pSortableColumn="status">
              {{'STATUS'| translate}}
              <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="DeptRemarks">
              {{'DEPT_REMARKS'| translate}}
              <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
              <p-sortIcon field="DeptRemarks"></p-sortIcon>
            </th>
            <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
              <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
              <p-sortIcon field="FinYear"></p-sortIcon>
            </th>

            <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>

            <!-- <th pSortableColumn="">{{'BOQ_ACTION'| translate}}</th> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
            <td>{{ product.appID }}</td>
            <!-- <td>{{product.remarks}}</td> -->
            <td>{{ product.FarmerName | uppercase }}</td>
            <td>{{ product.village }}</td>
            <td>{{ product.block }}</td>
            <td>{{ product.district }}</td>
            <td>{{ product.AgeOfApplication }}</td>
            <td>{{ product.ProgrammeName }}</td>
            <td>{{ product.LandDetail }}</td>
            <td>{{ product.Total_Area }}</td>
            <td>{{ product.PendingCompletedDays }}</td>
            <td>{{ product.Status_Ar }}</td>
            <td>{{ product.status }}</td>
            <td>{{ product.DeptRemarks }}</td>
            <td>{{product.FinYear}}</td>

            <td>
              <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                class="p-button-rounded p-button-accent mr-1 btnSize"
                (click)="selectFarmerApplication(product,product?.Status_Ar)"></button>
            </td>
            <!-- <td *ngIf="(product?.BOQStatus == '1')">
              <button (click)="updateBOQ(product)" icon="pi pi-pencil" pButton pRipple type="button"
                class="p-button-rounded p-button-text"></button>
            </td>
            <td *ngIf="(product?.BOQStatus == '2')">
              <button (click)="updateBOQ(product)" icon="pi pi-fw pi-plus" pButton pRipple type="button"
                class="p-button-rounded p-button-text"></button>
            </td> -->

            <!-- <td>
              <button pButton pRipple type="button" (click)="updateBOQ(product)" icon="pi pi-pencil"
                class="p-button-rounded p-button-text"></button>
            </td> -->
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            {{'IN_TOTAL_THERE_ARE'| translate}}
            {{ BOQtableData ? BOQtableData.length : 0 }} {{'VER_APP_ADDED'| translate}}
          </div><br>
          <div class="flex  justify-content-between flex-column ">
            <div class="flex">
              <div
                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
              </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
            </div>
            <div class="flex">
              <div
                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
              </div>{{'PENDING_BY_ONE_DAY'| translate}}
            </div>
            <div class="flex">
              <div
                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
              </div>{{'BOQ_ON_TIME'| translate}}
            </div>
            <div class="flex">
              <div
                style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
              </div>{{'DELAYED_APPROVED'| translate}}
            </div>
          </div>
        </ng-template>
      </p-table>
    </div>
  </p-card>
</div>

<p-confirmDialog [style]="{ width: '400px' }"></p-confirmDialog>

<p-dialog header="{{'BOQ_DETAILS'| translate}}" [(visible)]="displayBOQDialog" [modal]="true"
  [style]="{ width: '100%', height: '100%' }" [maximizable]="true" [draggable]="false" [resizable]="false"
  (onHide)="onCloseDialog()">
  <div *ngIf="tableDataAfterModification.length != 0">

    <div class="p-fluid p-formgrid grid justify-content-center">
      <div class="field col-6 md:col-4">
        <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeAppId
            }}</label></label>
      </div>

      <div class="field col-6 md:col-4">
        <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
            uppercase}}</label></label>
      </div>
    </div>

    <!-- Table Start -->
    <div class="card dashboardTable" style="margin: 5px">
      <!-- <p-table [value]="tableData" [rows]="10" [paginator]="true" [globalFilterFields]="['srNO', 'CatName', 'ComponentName', 'Size', 'Price', 'Quantity', 'Amount', 'GST', 'GSTAmount', 'AmountWithGST']" responsiveLayout="scroll" [(selection)]="tableData"
                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"> -->
      <p-table [value]="tableDataAfterModification" [rows]="10" [paginator]="false" [globalFilterFields]="[
          'srNO',
          'CatName',
          'ComponentName',
          'Size',
          'Price',
          'Quantity',
          'Amount',
          'GST',
          'GSTAmount',
          'AmountWithGST'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="id" [showCurrentPageReport]="true" editMode="row">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="srNO">{{'SR_NO'| translate}}</th>
            <th pSortableColumn="CatName">
              {{'CATEGORY_NAME'| translate}}
              <p-columnFilter type="text" field="CatName" display="menu"></p-columnFilter>
              <p-sortIcon field="CatName"></p-sortIcon>
            </th>
            <th pSortableColumn="ComponentName">
              {{'COMPONENT_NAME'| translate}}
              <p-columnFilter type="text" field="ComponentName" display="menu"></p-columnFilter>
              <p-sortIcon field="ComponentName"></p-sortIcon>
            </th>
            <th pSortableColumn="Size">
              {{'SIZE'| translate}}
              <p-columnFilter type="text" field="Size" display="menu"></p-columnFilter>
              <p-sortIcon field="Size"></p-sortIcon>
            </th>
            <th pSortableColumn="Price">
              {{'PRICE'| translate}}
              <p-columnFilter type="text" field="Price" display="menu"></p-columnFilter>
              <p-sortIcon field="Price"></p-sortIcon>
            </th>
            <th pSortableColumn="Quantity">
              {{'QUANTITY'| translate}}
              <p-columnFilter type="text" field="Quantity" display="menu"></p-columnFilter>
              <p-sortIcon field="Quantity"></p-sortIcon>
            </th>
            <th pSortableColumn="Amount">
              {{'AMOUNT'| translate}}
              <p-columnFilter type="text" field="Amount" display="menu"></p-columnFilter>
              <p-sortIcon field="Amount"></p-sortIcon>
            </th>
            <!-- <th pSortableColumn="GST">
              GST%
              <p-columnFilter type="text" field="GST" display="menu"></p-columnFilter>
              <p-sortIcon field="GST"></p-sortIcon>
            </th>
            <th pSortableColumn="GSTAmount">
              GST Amount
              <p-columnFilter type="text" field="GSTAmount" display="menu"></p-columnFilter>
              <p-sortIcon field="GSTAmount"></p-sortIcon>
            </th>
            <th pSortableColumn="AmountWithGST">
              Amount with GST
              <p-columnFilter type="text" field="AmountWithGST" display="menu"></p-columnFilter>
              <p-sortIcon field="AmountWithGST"></p-sortIcon>
            </th> -->
            <th>{{'EDIT'| translate}}</th>
            <th>{{'DELETE'| translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-editing="editing" let-rowIndex="rowIndex">
          <tr [pEditableRow]="product">
            <td>{{ rowIndex + 1 }}</td>
            <td>{{ product.CatName }}</td>
            <td>{{ product.ComponentName }}</td>
            <td>{{ product.Size }}</td>
            <td>Rs. {{ product.Price | number: "1.2-2" }}</td>

            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input [ngClass]="{
                      'ng-invalid ng-dirty':
                        product.Quantity < 1 || product.Quantity > quantity
                    }" pInputText type="number" [(ngModel)]="product.Quantity" min="1" step="1"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                  <div class="invalid-feedback" *ngIf="product.Quantity < 1">
                    {{'MUST_BE_GRT_OR_EQUAL_TO_ONE'| translate}}
                  </div>
                  <div class="invalid-feedback" *ngIf="product.Quantity > quantity">
                    {{'MUST_BE_LESS_THAN_OR_EQUAL'| translate}} {{ quantity }}
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  {{ product.Quantity }}
                </ng-template>
              </p-cellEditor>
            </td>

            <td>{{'RS.'| translate}} {{ product.Amount | number: "1.2-2" }}</td>
            <!-- <td>{{ product.GST }}%</td>

            <td>Rs.{{ product.GSTAmount | number: "1.2-2" }}</td>

            <td>Rs. {{ product.AmountWithGST | number: "1.2-2" }}</td> -->
            <td style="text-align: center">
              <!-- <button *ngIf="!editing && product?.inventory.length!=0" pButton pRipple type="button" icon="pi pi-check"
                (click)="onRowEditInitForInventory(product)" class="p-button-rounded p-button-text"></button>
              <button *ngIf="!editing && product?.inventory.length==0" [disabled]="isOpenforEditing" pButton pRipple
                type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(product)"
                class="p-button-rounded p-button-text"></button> -->
              <button *ngIf="!editing" [disabled]="isOpenforEditing" pButton pRipple
                type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(product)"
                class="p-button-rounded p-button-text"></button>
              <button *ngIf="editing" [disabled]="product.Quantity < 1 || product.Quantity > quantity" pButton pRipple
                type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(product)"
                class="p-button-rounded p-button-text p-button-success mr-2"></button>
              <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                (click)="onRowEditCancel()" class="p-button-rounded p-button-text p-button-danger"></button>
            </td>
            <td>
              <button pButton pRipple type="button" icon="pi pi-times" (click)="onRowDelete(rowIndex)"
                class="p-button-rounded p-button-text p-button-danger"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- Table End -->

    <!-- Final Estimation Details Start -->
    <div class="col-12">
      <div class="card estiamtion-header">
        <!-- <h4>Estimation Header Details</h4> -->
        <form [formGroup]="finalEstimationDetails">
          <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-2">
              <label htmlFor="plantSpacing">{{'PLANT_SPACING'| translate}}</label>
              <input readonly formControlName="plantSpacing" pInputText id="plantSpacing" type="number" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.plantSpacing.touched &&
                    finalEstimationControls.plantSpacing.errors
                }" />
              <div *ngIf="
                  finalEstimationControls.plantSpacing.touched &&
                  finalEstimationControls.plantSpacing.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.plantSpacing.errors.required">
                  {{'ON_INVALID_PLANT_SPACING'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="rowSpacing">{{'ROW_SPACING'| translate}}</label>
              <input readonly formControlName="rowSpacing" pInputText id="rowSpacing" type="number" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.rowSpacing.touched &&
                    finalEstimationControls.rowSpacing.errors
                }" />
              <div *ngIf="
                  finalEstimationControls.rowSpacing.touched &&
                  finalEstimationControls.rowSpacing.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.rowSpacing.errors.required">
                  {{'ON_INVALID_ROW_SPACING'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="latitude">{{'LATITUDE'| translate}}</label>
              <input readonly formControlName="latitude" pInputText id="latitude" type="number" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.latitude.touched &&
                    finalEstimationControls.latitude.errors
                }" />
              <div *ngIf="
                  finalEstimationControls.latitude.touched &&
                  finalEstimationControls.latitude.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.latitude.errors.required">
                  {{'LATITUDE_IS_REQUIRED'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="longitude">{{'LONGITUDE'| translate}}</label>
              <input readonly formControlName="longitude" pInputText id="longitude" type="number" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.longitude.touched &&
                    finalEstimationControls.longitude.errors
                }" />
              <div *ngIf="
                  finalEstimationControls.longitude.touched &&
                  finalEstimationControls.longitude.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.longitude.errors.required">
                  {{'LONGITUDE_IS_REQUIRED'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="crop">{{'CROP'| translate}}</label>
              <p-autoComplete formControlName="crop" placeholder="Select Crop" id="crop" [dropdown]="true"
                [multiple]="false" [suggestions]="filteredCrop" (completeMethod)="filterCrop($event)" field="label"
                value="" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.crop.touched &&
                    finalEstimationControls.crop.errors
                }">
              </p-autoComplete>
              <div *ngIf="
                  finalEstimationControls.crop.touched &&
                  finalEstimationControls.crop.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.crop.errors.required">
                  {{'CROP_IS_REQ'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="discountRate">{{'DISCOUNT_RATE'| translate}}</label>
              <input formControlName="discountRate" pInputText id="discountRate" type="number" min="0" max="100"
                (ngModelChange)="onMIAreaChange()" />
            </div>

            <!-- <div class="field col-12 md:col-2">
              <label htmlFor="taxRate">Tax Rate</label>
              <input
                readOnly
                formControlName="taxRate"
                pInputText
                id="taxRate"
                type="number"
                [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.taxRate.touched &&
                    finalEstimationControls.taxRate.errors
                }"
              />
              <div
                *ngIf="
                  finalEstimationControls.taxRate.touched &&
                  finalEstimationControls.taxRate.errors
                "
                class="invalid-feedback"
              >
                <div *ngIf="finalEstimationControls.taxRate.errors.required">
                  Tax Rate is required
                </div>
              </div>
            </div> -->

            <div class="field col-12 md:col-2">
              <label htmlFor="MIArea">{{'MI_AREA'| translate}}</label>
              <input formControlName="MIArea" pInputText id="taxRate" (ngModelChange)="onMIAreaChange()" type="number"
                min="0" max="miArea" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.MIArea.touched &&
                    finalEstimationControls.MIArea.errors
                }" />
              <div class="invalid-feedback" *ngIf="
                  finalEstimationControls.MIArea.touched &&
                  finalEstimationControls.MIArea.errors
                ">
                <div *ngIf="finalEstimationControls.MIArea.errors?.required">
                  {{'MI_AREA_IS_REQ'| translate}}
                </div>
                <div *ngIf="
                    finalEstimationControls.MIArea.errors?.min ||
                    finalEstimationControls.MIArea.errors?.max
                  ">
                  {{'MI_AREA_MUST_BE_FROM'| translate}}-{{ miArea }}.
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="remarks">{{'REMARKS'| translate}}</label>
              <input formControlName="remarks" pInputText id="remarks" type="text" [ngClass]="{
                  'ng-invalid ng-dirty':
                    finalEstimationControls.remarks.touched &&
                    finalEstimationControls.remarks.errors
                }" />
              <div *ngIf="
                  finalEstimationControls.remarks.touched &&
                  finalEstimationControls.remarks.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.remarks.errors.required">
                  {{'REMARKS_IS_REQ'| translate}}
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="block">{{'LAND_MAP'| translate}}</label>
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" #vendorBOQLandMapPath [customUpload]="true" (uploadHandler)="
                    onUpload($event, 'landMapPath', vendorBOQLandMapPath)
                  " name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                  [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="finalEstimationControls.landMapPath.value"
                  [src]="finalEstimationControls.landMapPath.value" alt="Image" width="60"
                  class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
              </div>
              <div *ngIf="
                  finalEstimationControls.landMapPath.touched &&
                  finalEstimationControls.landMapPath.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.landMapPath.errors.required">
                  {{'LAND_MAP_IS_REQ'| translate}}
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-2">
              <label htmlFor="block">{{'UPLOAD_BILL_COPY'| translate}}</label>
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" #vendorBOQBillCopyPath [customUpload]="true" (uploadHandler)="
                    onUpload($event, 'billCopyPath', vendorBOQBillCopyPath)
                  " name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                  [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="finalEstimationControls.billCopyPath.value"
                  [src]="finalEstimationControls.billCopyPath.value" alt="Image" width="60"
                  class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
              </div>
              <div *ngIf="
                  finalEstimationControls.billCopyPath.touched &&
                  finalEstimationControls.billCopyPath.errors
                " class="invalid-feedback">
                <div *ngIf="finalEstimationControls.billCopyPath.errors.required">
                  {{'BILL_COPY_IS_REQ'| translate}}
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-2">
              <label htmlFor="signature">{{'SIGNATURE'| translate}}</label>
              <p>
                <a style="cursor: pointer" [href]="signaturePath" target="_blank">{{'VIEW_IMAGE' | translate}}</a>
              </p>
            </div>
          </div>
          <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-2">
              <label htmlFor="componentTotal"> {{'COMPONENT_TOTAL'| translate}}:</label>
              <p>
                <label>{{'RS.'| translate}} {{ estimatedComponentTotal -
                  (estimatedComponentTotal*finalEstimationDetails.value.discountRate)/100 | number: "1.2-2" }}/-</label>
              </p>
            </div>

            <!-- <div class="field col-12 md:col-2">
              <label htmlFor="gstTotal">GST Total :</label>
              <p>
                <label>Rs. {{ estimatedGSTTotal -
                  (estimatedGSTTotal*finalEstimationDetails.value.discountRate)/100 | number: "1.2-2" }}/-</label>
              </p>
            </div> -->
            <div class="field col-12 md:col-2">
              <label htmlFor="farmerName">{{'TRANSPORT_OTHER_CHARGES'| translate}}</label>
              <p>
                <label>{{'RS.'| translate}}
                  {{
                  isTransportFree
                  ? 00
                  : (2500 * finalEstimationDetails.value.MIArea
                  | number: "1.2-2")
                  }}/-</label>
              </p>
              <!-- <input readonly formControlName="transOtherCharges" pInputText id="transOtherCharges" type="number"
                    [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.transOtherCharges.touched && finalEstimationControls.transOtherCharges.errors }" />
                <div *ngIf="finalEstimationControls.transOtherCharges.touched && finalEstimationControls.transOtherCharges.errors"
                    class="invalid-feedback">
                    <div *ngIf="finalEstimationControls.transOtherCharges.errors.required">Transaction/Other
                        Charges is required
                    </div>
                </div> -->
            </div>
            <div class="field col-12 md:col-2">
              <label htmlFor="grandTotal">{{'GRAND_TOTAL'| translate}}:</label>
              <p>
                <label>{{'RS.'| translate}} {{grandTotal| number :
                  '1.2-2'}}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="subsidyAmount">{{'REMARKS'| translate}} :</label>
              <p><label>{{'RS.'| translate}} {{(((isTransportFree ? 00 : 2500 * finalEstimationDetails.value.MIArea) +
                  ((estimatedGrandTotal - estimatedGSTTotal) -
                  estimatedGrandTotal*finalEstimationDetails.value.discountRate/100)) *85) /100 |
                  number: "1.2-2"}}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="farmerShare">{{'FARMER_SHARE'| translate}} :</label>


              <p><label>{{'RS.'| translate}} {{(((isTransportFree ? 00 : 2500 * finalEstimationDetails.value.MIArea) +
                  ((estimatedGrandTotal - estimatedGSTTotal) -
                  estimatedGrandTotal*finalEstimationDetails.value.discountRate/100)) *15) /100 |
                  number: "1.2-2"}}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-2">
              <!-- pro data calculations -->
              <div class="mt-2 proDataButton">
                <button (click)="proDataCalculation()" pButton pRipple type="submit"
                  label="{{'VIEW_PRO_DATA_MAX_SUBSIDY_CAL'| translate}}" class="p-button-info mr-2 mb-2"></button>
              </div>
              <div *ngIf="showProDataCalError" class="invalid-feedback mb-2">
                <!-- <div *ngIf="finalEstimationControls?.rowSpacing?.errors?.required">Row Spacing is
                                    required
                                </div>
                                <div *ngIf="finalEstimationControls?.plantSpacing?.errors?.required">Plant Spacing is
                                    required
                                </div> -->
                <div *ngIf="finalEstimationControls?.MIArea?.errors?.required">
                  {{'MI_AREA_SPACING_IS_REQ'| translate}}
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData">
            <div class="field col-12 md:col-3">
              <label htmlFor="pro-data">{{'PRO_DATA_MAX_SUBSIDY_FORMULA'| translate}}:</label>
              <p>
                <label>{{ proCalculatedData.Formula }}</label>
              </p>
            </div>

            <div class="field col-12 md:col-3">
              <label htmlFor="output">{{'OUTPUT'| translate}} :</label>
              <p>
                <label>{{ proCalculatedData.Output }}</label>
              </p>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="amount">{{'AMOUNT'| translate}} :</label>
              <p>
                <label>Rs. {{ proCalculatedData.Amount }}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-1">
              <label htmlFor="maxSubsidy">{{'MAX_SUBSIDY'| translate}} :</label>
              <p>
                <label>Rs. {{ proCalculatedData.maxSubsidy }}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-1">
              <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT'| translate}} :</label>
              <p>
                <label>Rs. {{ proCalculatedData.TransportAmount }}/-</label>
              </p>
            </div>

            <div class="field col-12 md:col-2">
              <label htmlFor="result">{{'RESULT'| translate}}</label>
              <p>
                <label>{{ proCalculatedData.Result }}</label>
              </p>
            </div>
          </div>

          <button (click)="submitFinalEstimation()" pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
            class="p-button-success mr-2 mb-2"
            [disabled]="finalEstimationDetails.invalid || !isProDataCalculated"></button>
        </form>
      </div>
    </div>
    <!-- Final Estimation Details End -->
  </div>
  <!-- Content End-->
</p-dialog>


<p-dialog header="{{'INVENTORY_DETAILS'| translate}}" [(visible)]="dialogBoxForinventory" [modal]="true"
  [style]="{ width: '70%', height: '90%' }" [maximizable]="true" [draggable]="false" [resizable]="false"
  (onHide)="onCloseInventoryDialog()">
  <div class="inventory-details-container card">
    <div class="p-fluid p-formgrid grid justify-content-center">
      <div class="field col-12 md:col-6">
        <label>{{'CATEGORY_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
            inventoryDataForGrid?.CatName }}</label></label>
      </div>
      <div class="field col-12 md:col-6">
        <label>{{'COMPONENT_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
            inventoryDataForGrid?.ComponentName }}</label></label>
      </div>
      <div class="field col-12 md:col-6">
        <label>{{'SIZE_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ inventoryDataForGrid?.Size
            }}</label></label>
      </div>
      <div class="field col-12 md:col-6">
        <label>{{'QUANTITY'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ inventoryDataForGrid?.Quantity
            }}</label></label>
      </div>
    </div>
  </div>


  <!-- <p-card styleClass="p-card-shadow"> -->
  <div class="card dashboardTable">
    <p-table #miSurvey [value]="inventoryDataForGrid?.inventory" [(selection)]="inventoryRowFilteredData"
      dataKey="batchNumber_lotNo" (onRowSelect)="onInventoryRowSelect($event)"
      (onRowUnselect)="onInventoryRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
      [rows]="10" [paginator]="true" [globalFilterFields]="[
                'batchNumber',
                'lotNo',
                'remainingQuantity', 
                'quantityUsed',
                ]" responsiveLayout="scroll" [rowHover]="true"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true">

      <ng-template pTemplate="header">

        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th pSortableColumn="batchNumber">{{'BATCH_NUMBER'| translate}}</th>
          <th pSortableColumn="lotNo">{{'LOT_NO'| translate}}</th>
          <th pSortableColumn="remainingQuantity">{{'REMAINING_QUANTITY'| translate}}</th>
          <th pSortableColumn="quantityUsed">{{'QUANTITY_USED'| translate}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <p-tableCheckbox [value]="product"></p-tableCheckbox>
          </td>
          <td>{{product.batchNumber}}</td>
          <td>{{product.lotNo}}</td>
          <td>{{product.remainingQuantity}}</td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="number" min="0" required [(ngModel)]="product.quantityUsed"
                  (change)="onEditComplete(product)" [style]="{'background-color': 'rgb(211, 209, 209)'}"
                  [ngClass]="{
                      'ng-invalid ng-dirty': product.quantityUsed < 0 || product.quantityUsed > product.remainingQuantity }" />
                <div class="invalid-feedback" *ngIf="product.quantityUsed < 0">
                  {{'Must not be negative'| translate}}
                </div>
                <div class="invalid-feedback" *ngIf="product.quantityUsed > product.remainingQuantity">
                  {{'Qunatity must not be greater than Remaining Quantity'| translate}} {{ quantity }}
                </div>
              </ng-template>
              <ng-template pTemplate="output">
                {{ product.quantityUsed }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          {{'IN_TOTAL_THERE_ARE'| translate}} {{inventoryDataForGrid?.inventory ?
          inventoryDataForGrid?.inventory?.length : 0 }}
          {{'INVENTORY'| translate}}
        </div>
      </ng-template>
    </p-table>
  </div>
  <div class="card" *ngIf="inventoryDataForGrid?.inventory?.length">
    <h5 [style]="{color: 'rgb(168, 32, 32)'}"><b>{{'TOTAL_SELECTED_QUANTITY_USED'| translate}} {{ totalQuantityUsed }}
      </b></h5>
    <div class="d-flex" *ngIf="totalQuantityUsed > inventoryDataForGrid?.Quantity">
      <p class="d-flex justify-content-center" [style]="{color: 'red'}"><b>{{'TOTAL_SELECTED_QUANTITY_USED_MUST_NOT_BE_GREATER_THAN_QUANTITY'| translate}}</b></p>
    </div>
  </div>
  <button (click)="submitInventoryDetails()" [disabled]="totalQuantityUsed > inventoryDataForGrid?.Quantity" pButton
    pRipple type="submit" label="{{'SUBMIT'| translate}}" class="p-button-success mr-2 mb-2 ml-4"></button>
  <!-- </p-card> -->
  <!-- </div> -->
</p-dialog>